module.exports = __webpack_public_path__ + "static/media/blom-pysanky-thumb-27.2992b956.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blom-pysanky/blom-pysanky-thumb-27.jpg
// module id = 3982
// module chunks = 13